import { StationType } from '../entities/station';
import { ResCreateStation } from '../types/api-types';
import { BaseOrganizationEndpoints } from './base';
import { ResponseWithStatus } from './response/response_with_status';
import {
  LoginStationPayload,
  LoginStationResponse
} from './visitor-manager';

export class Unauthenticated extends BaseOrganizationEndpoints {
  async stationAdd(
    otp: string,
    type: StationType
  ): Promise<ResponseWithStatus<ResCreateStation>> {
    return await this.requestWithStatus<ResCreateStation>('POST', `/stations`, {
      code: otp,
      type: type
    });
  }

  async stationLogin(
    payload: LoginStationPayload
  ): Promise<ResponseWithStatus<LoginStationResponse>> {
    return await this.requestWithStatus<LoginStationResponse>(
      'POST',
      '/v1/visitor_management/stations/login',
      payload
    );
  }

  async countries() {
    return this.requestWithStatus<{ [id: string]: string }>(
      'GET',
      `/countries`
    );
  }
}
